import Swiper, { Navigation, Pagination, EffectCreative } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-creative';


export default class CharaGallery{

    constructor(){
        this.swiper = null;
        this.$gallery = document.querySelector('.gallery');
        this.illustrators =[...document.querySelectorAll('.js-illustrator__item')];
        this._init();
    }

    _init(){
        this._setSwiper();
        this._ui();
    }


    _setSwiper(){

        this.swiper = new Swiper('.gallery .swiper', {
            modules: [ Navigation, Pagination, EffectCreative ],
            speed: 500,            
            effect: 'creative',
            creativeEffect: {
                prev: {
                    opacity: 0,
                    shadow: false,
                    translate: ['-30%', 0, -150],
                },
                next: {
                    opacity: 0,
                    shadow: false,
                    translate: ['30%', 0, -150],
                },
            },
            loop:true,
            navigation: {
                nextEl: '.js-gallery__next',
                prevEl: '.js-gallery__prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                type: 'bullets'
            },
            observer: true,
            observeParents: true
        });

        this.swiper.on('slideChangeTransitionStart', ()=>{
            this.$gallery.scrollTop = 0;
            const idx = document.querySelector('.swiper-slide-active').getAttribute('data-swiper-slide-index');
            this.$gallery.setAttribute('data-swiper-index', idx);
        });
    }


    _ui(){

        [...document.querySelectorAll('.js-gallerybtn')].forEach($item=>{

            $item.addEventListener('click', ()=>{
                const idx = $item.getAttribute('data-index');
                this.swiper.slideToLoop(idx, 0);
            });
        });
    }
}